import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx } from "@emotion/react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { isEqual } from "lodash";

import { selectEvents } from "reducers/eventReducer";

import Tabs from "./Tabs";
import { Tab } from "./Styles";

const selectBookingEnabled = (state) =>
  state.business?.business?.bookingEnabled;
const selectOnlineWaitlistEnabled = (state) =>
  state.business?.business?.onlineWaitlistEnabled;
const selectOnlineOrderingEnabled = (state) =>
  state.business?.business?.onlineOrderingEnabled;

export default function CustomTabs(props) {
  const businessUid = useParams().id;
  const bookingEnabled = useSelector(selectBookingEnabled);
  const onlineWaitlistEnabled = useSelector(selectOnlineWaitlistEnabled);
  const onlineOrderingEnabled = useSelector(selectOnlineOrderingEnabled);
  //lazycat-riyadh  is facing an issue with a customer who doesn't know English and wishes to change the label of the waitlist tab to Arabic
  const waitlistLabel =
    businessUid === "lazycat-riyadh" ? "Waitlist | قائمة الانتظار" : "Waitlist";
  const { events } = useSelector(selectEvents, isEqual);

  return (
    <Tabs>
      <Tab label="Overview" value="overview" />
      {onlineOrderingEnabled && <Tab label="Order Online" value="order" />}
      {bookingEnabled && <Tab label="Book" value="book" />}
      {onlineWaitlistEnabled && <Tab label={waitlistLabel} value="waitlist" />}
      {events?.length > 0 && <Tab label="Events" value="events" />}
    </Tabs>
  );
}
